/**
 * @generated SignedSource<<89e163bb600e6d87576edad7f95fc68f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MusicDeletePieceInput = {
  piece_id: string;
};
export type DeleteMusicPieceMutation$variables = {
  input: MusicDeletePieceInput;
};
export type DeleteMusicPieceMutation$data = {
  readonly music_delete_piece: {
    readonly piece: {
      readonly id: string;
      readonly deleted: boolean;
    };
  };
};
export type DeleteMusicPieceMutation = {
  variables: DeleteMusicPieceMutation$variables;
  response: DeleteMusicPieceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MusicPieceOutput",
    "kind": "LinkedField",
    "name": "music_delete_piece",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicPiece",
        "kind": "LinkedField",
        "name": "piece",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deleted",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteMusicPieceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteMusicPieceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d06bd5e94a5acaf1d8e2fc50a06db155",
    "id": null,
    "metadata": {},
    "name": "DeleteMusicPieceMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteMusicPieceMutation(\n  $input: MusicDeletePieceInput!\n) {\n  music_delete_piece(input: $input) {\n    piece {\n      id\n      deleted\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a47114a8120007b870b30fb288ecb8b7";

export default node;
